import { addItemToCollection } from "directus/src/operations";

export async function createCaseStudy({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "status",
                "name",
                "project",
                "project_name_alias",
                "date_started",
                "tag_line",
                "client_requirement",
                "solution_overview",
                "obstacles",
                "achievements",
                "team_size",
                "duration",
                "screenshots",
                "testimonials",
                "tools",
                "tech_stack",
                "outcomes",
                "deliverables",
                "methodology",
                "video",
                "nda_level",
                "industry",
            ],
        };

        const data = await addItemToCollection("case_studies", item, query);

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
